// Vertical rhythm shared by the blocks inside an article body (embeds, videos, images, tables, forms)
export const ARTICLE_BLOCK_SPACING = 'my-3xl lg:my-5xl'
